<template>
  <div></div>
</template>

<script>

export default {
  name:"Callback",
  data(){
    return {
      token: null
    }
  },
  created() {
    let loading = this.$loading({
      lock: true,
      text: '正在登录',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    try {
      this.init()
    } finally {
      loading.close()
    }
  },
  methods: {
    init() {
      let query = this.$route.query
      if(!query.access_token) {
        return this.$router.push("/401")
      }
      // 将登录结果存入cookie
      this.$store.dispatch('user/saveToken', {"token":query.access_token, "mode": "safe"})
      // 跳转到授权页面
      this.$router.push({path: "/authorize"})
    }
  }
}
</script>

<style>

</style>